import { listAdmissions } from "@/core/admissions/admission-store";
import type { Admission } from "@/core/admissions/types";

function admissionDestinations(adm: Admission): string[] {
  return adm.destinations.length
    ? adm.destinations
    : adm.destination
      ? [adm.destination]
      : [];
}

export function listSurgeryOrientations(): Admission[] {
  return listAdmissions()
    .filter((a) => {
      const dests = admissionDestinations(a);
      return dests.some((d) => /chirurg/i.test(d));
    })
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
}

export function listAmbulanceTransports(): Admission[] {
  return listAdmissions("emergency")
    .filter((a) => a.arrivalMode === "ambulance")
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
}
